import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActionReducerMap, createAction, StoreModule } from '@ngrx/store';

import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { AuthStateModule } from './auth/auth-state.module';
import { UserStateModule } from './user/user-state.module';
import { AdminStateModule } from './admin/admin-state.module';
import { BookStateModule } from './book/book-state.module';
import { TrackingStateModule } from './tracking/tracking-state.module';
import { SubscriptionStateModule } from './subscription/subscription-state.module';
import { ReportStateModule } from './reporting/report-state.module';

export const EmptyAction = createAction('Empty Action');

export type AsyncStatus = 'NotFetched' | 'Loading' | 'Success' | 'Failure';

export interface AsyncState {
    status: AsyncStatus;
    error?: string;
}

export interface AppState { }

export const appReducer: ActionReducerMap<AppState> = {};

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forRoot(appReducer),
        AuthStateModule,
        UserStateModule,
        SubscriptionStateModule,
        AdminStateModule,
        BookStateModule,
        TrackingStateModule,
        ReportStateModule,
        EffectsModule.forRoot([]),
        StoreDevtoolsModule.instrument({
            maxAge: 25
        })
    ],
    providers: [],
})
export class RootStoreStateModule { }
